import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import Icon from '../icon';
import throttle from 'lodash/throttle';
import Draggable from 'react-draggable';

var Preview = function Preview(props) {
  var _context;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var allProps = getCompProps('Image', userDefaultProps, props);
  var src = allProps.src,
      alt = allProps.alt,
      name = allProps.name,
      size = allProps.size,
      scales = allProps.scales,
      visible = allProps.visible,
      onClose = allProps.onClose,
      current = allProps.current,
      length = allProps.length,
      operations = allProps.operations,
      customPrefixcls = allProps.prefixCls; // className前缀

  var prefixCls = getPrefixCls(pkgPrefixCls, 'image', customPrefixcls);

  var _React$useState = React.useState(visible),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      show = _React$useState2[0],
      setShow = _React$useState2[1];

  React.useEffect(function () {
    setShow(visible);
    visible && setPreviewSrc(src);
  }, [visible, src]);

  var _React$useState3 = React.useState(src),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      previewSrc = _React$useState4[0],
      setPreviewSrc = _React$useState4[1];

  var _React$useState5 = React.useState(1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      scale = _React$useState6[0],
      setScale = _React$useState6[1];

  var maxScale = scales[scales.length - 1] / 100;
  var minScale = scales[0] / 100;
  React.useEffect(function () {
    if (show) {
      document.body.style.overflow = 'hidden';
      var throMouseWheel = throttle(function (e) {
        if (e.wheelDelta > 0) {
          if (scale > maxScale) return;

          if (scale + 0.1 > maxScale) {
            setScale(maxScale);
          } else {
            setScale(scale + 0.1);
          }
        } else if (e.wheelDelta < 0) {
          if (scale < minScale) return;

          if (scale - 0.1 < minScale) {
            setScale(minScale);
          } else {
            setScale(scale - 0.1);
          }
        }
      }, 200);
      document.addEventListener('mousewheel', throMouseWheel);
      return function () {
        document.removeEventListener('mousewheel', throMouseWheel);
      };
    } else {
      document.body.style.overflow = '';
      setScale(1);
    }
  }, [show, scale]);

  var handleZoomOut = function handleZoomOut() {
    var nextScale = scales.findLast(function (s) {
      return s / 100 < scale;
    });
    if (nextScale !== undefined) setScale(nextScale / 100);
  };

  var handleZoomIn = function handleZoomIn() {
    var nextScale = _findInstanceProperty(scales).call(scales, function (s) {
      return s / 100 > scale;
    });

    if (nextScale !== undefined) setScale(nextScale / 100);
  };

  var previewImgProps = {
    alt: alt,
    src: previewSrc,
    draggable: 'false',
    className: "".concat(prefixCls, "-preview-img"),
    style: {
      transform: _concatInstanceProperty(_context = "scale3d(".concat(scale, ", ")).call(_context, scale, ", 1)")
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  };
  var peviewContainer = /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-preview"), props.className, {
      show: show
    }),
    style: _extends({}, props.style)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-preview-mask"),
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Draggable, {
    defaultClassName: "".concat(prefixCls, "-preview-wrap"),
    position: {
      x: 0,
      y: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", _extends({}, previewImgProps)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-preview-action")
  }, props.type !== 'upload' && length && /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left",
    className: classNames({
      disabled: current <= 0
    }),
    onClick: props.onPrevious
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "shrink",
    className: classNames({
      disabled: scale <= minScale
    }),
    onClick: handleZoomOut
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "zoom",
    className: classNames({
      disabled: scale >= maxScale
    }),
    onClick: handleZoomIn
  }), props.type !== 'upload' && operations, props.type !== 'upload' && length && /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right",
    className: classNames({
      disabled: current >= length - 1
    }),
    onClick: props.onNext
  })), props.type === 'upload' && length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-preview-previous")
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left",
    style: {
      fontSize: 20
    },
    className: classNames({
      disabled: current <= 0
    }),
    onClick: props.onPrevious
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-preview-next")
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right",
    style: {
      fontSize: 20
    },
    className: classNames({
      disabled: current >= length - 1
    }),
    onClick: props.onNext
  }))), props.type !== 'upload' && /*#__PURE__*/React.createElement(Icon, {
    className: "".concat(prefixCls, "-preview-close"),
    type: "close-solid",
    onClick: onClose
  }), props.type === 'upload' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-preview-topbar")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-preview-topbar-info")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-preview-topbar-info-name")
  }, name), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-preview-topbar-info-size")
  }, size)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-preview-topbar-action")
  }, operations, /*#__PURE__*/React.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close-solid"
  }), "\u5173\u95ED"))));
  return /*#__PURE__*/ReactDOM.createPortal(peviewContainer, document.body);
};

export default Preview;